import { render, staticRenderFns } from "./BorrowEchart.vue?vue&type=template&id=3aca4497&scoped=true&"
import script from "./BorrowEchart.vue?vue&type=script&lang=js&"
export * from "./BorrowEchart.vue?vue&type=script&lang=js&"
import style0 from "./BorrowEchart.vue?vue&type=style&index=0&id=3aca4497&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aca4497",
  null
  
)

export default component.exports